import React from 'react';

import classes from './NoDataFallback.module.scss';

export const NoDataFallback: React.VFC = () => {
  return <div className={classes.root}>Ничего не найдено</div>;
};
